import React, { useEffect, useState, useRef } from 'react';
import { TextField, Button, Grid, Paper, Typography, Autocomplete, Radio, RadioGroup, FormControlLabel, FormControl, FormLabel, Collapse, TableCell, TableBody, Checkbox } from '@mui/material';
import { useAuth } from '../../contexts/AuthContext';
import api from '../../api/api';
import { useNavigate } from 'react-router-dom';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker, LocalizationProvider, TimePicker } from '@mui/x-date-pickers';

export default function UniformRequirementForm() {

  const { user, token } = useAuth();
  const navigate = useNavigate();

  const [managers, setManagers] = useState([]);

  useEffect(() => {
    if (user) {
      const tempValues = { ...formValue }
      tempValues.empId = user.employee_code;
      tempValues.empName = user['http://schemas.xmlsoap.org/ws/2005/05/identity/claims/name'];
      setFormValue(tempValues);
    }
  }, [user]);

  const [formValue, setFormValue] = useState({
    empId: '',
    empName: '',
    isRegularDaysFullSleeveTshirt: false,
    isRegularDaysHalfSleeveTshirt: false,
    isSaturdayTshirt: false,
    isTrouser: false,
    tShirtSize: '',
    trouserSize: '',
    reasonOfRequirement: '',
    approvalManager: '',
  });

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormValue((prevValues) => ({
      ...prevValues,
      [name]: value
    }));
  }

  const handleCheckBoxChange = (event) => {
    const { name, type, value, checked } = event.target;
    setFormValue((prevValues) => ({
      ...prevValues,
      [name]: type === 'checkbox' ? checked : value,
    }));
  };


  useEffect(() => {
    getManagers();
  },
    []);

  const getManagers = () => {
    api.get('/api/Users/get_managers')
      .then(response => {
        setManagers(response.data);
      })
      .catch(error => {
        console.error('Error fetching managers', error);
      });
  }

  const handleSubmit = (e) => {
    e.preventDefault();

    const requestData = {
      employeeId: +user["http://schemas.xmlsoap.org/ws/2005/05/identity/claims/nameidentifier"],
      approvalManagerId: formValue.approvalManager,
      isRegularDaysFullSleeveTshirt: formValue.isRegularDaysFullSleeveTshirt,
      isRegularDaysHalfSleeveTshirt: formValue.isRegularDaysHalfSleeveTshirt,
      isSaturdayTshirt: formValue.isSaturdayTshirt,
      isTrouser: formValue.isTrouser,
      tShirtSize: +formValue.tShirtSize,
      trouserSize: +formValue.trouserSize,
      reasonOfRequirement: formValue.reasonOfRequirement,
    };
    api.post('/api/UniformRequirement', requestData)
      .then(response => {
        navigate('/uniform-request')
      })
      .catch(error => {
        console.error('Error submitting request', error);
        // Handle error
      });
  }

  return (
    <Paper
      sx={{
        p: 2,
        display: 'flex',
        flexDirection: 'column',
        maxWidth: 1200,
        margin: 'auto'
      }}
    >
      <Typography marginBottom={2} component="p" variant="h5">New Uniform Requirement Request</Typography>
      <form sx={{ top: 200 }} onSubmit={handleSubmit}>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6}>
            <TextField
              label="Emp. ID"
              name="empId"
              value={formValue.empId}
              InputProps={{ readOnly: true }}
              fullWidth
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              label="Emp Name"
              name="empName"
              value={formValue.empName}
              InputProps={{ readOnly: true }}
              fullWidth
            />
          </Grid>
          
            {/* Checkboxes */}
            <TableCell align="center" sx={{ borderBottom: 'none' }}>
              <FormControlLabel
                control={
                  <Checkbox
                    name="isRegularDaysFullSleeveTshirt"
                    checked={formValue.isRegularDaysFullSleeveTshirt}
                    onChange={handleCheckBoxChange}
                  />
                }
                label="Regular Days Full Sleeve T-Shirt"
              />
            </TableCell>
            <TableCell align="center" sx={{ borderBottom: 'none' }}>
              <FormControlLabel
                control={
                  <Checkbox
                    name="isRegularDaysHalfSleeveTshirt"
                    checked={formValue.isRegularDaysHalfSleeveTshirt}
                    onChange={handleCheckBoxChange}
                  />
                }
                label="Regular Days Half Sleeve T-Shirt"
              />
            </TableCell>
            <TableCell align="center" sx={{ borderBottom: 'none' }}>
              <FormControlLabel
                control={
                  <Checkbox
                    name="isSaturdayTshirt"
                    checked={formValue.isSaturdayTshirt}
                    onChange={handleCheckBoxChange}
                  />
                }
                label="Saturday T-Shirt"
              />
            </TableCell>
            <TableCell align="center" sx={{ borderBottom: 'none' }}>
              <FormControlLabel
                control={
                  <Checkbox
                    name="isTrouser"
                    checked={formValue.isTrouser}
                    onChange={handleCheckBoxChange}
                  />
                }
                label="Trouser"
              />
            </TableCell>

            {/* T-Shirt Size Field */}
            {formValue.isRegularDaysFullSleeveTshirt || formValue.isRegularDaysHalfSleeveTshirt || formValue.isSaturdayTshirt ? (
              <Grid item xs={12} sm={6}>
                <TextField
                  label="T-Shirt Size"
                  name="tShirtSize"
                  type="number"
                  inputProps={{ min: 1, required: true }}
                  onWheel={(e) => e.target.blur()}
                  value={formValue.tShirtSize || ''}
                  onChange={handleInputChange}
                  fullWidth
                  required
                  error={!formValue.tShirtSize}
                  helperText={!formValue.tShirtSize ? 'T-Shirt Size is required' : ''}
                />
              </Grid>
            ) : null}

            {/* Trouser Size Field */}
            {formValue.isTrouser ? (
              <Grid item xs={12} sm={6}>
                <TextField
                  label="Trouser Size"
                  name="trouserSize"
                  type="number"
                  inputProps={{ min: 1, required: true }}
                  onWheel={(e) => e.target.blur()}
                  value={formValue.trouserSize || ''}
                  onChange={handleInputChange}
                  fullWidth
                  required
                  error={!formValue.trouserSize}
                  helperText={!formValue.trouserSize ? 'Trouser Size is required' : ''}
                />
              </Grid>
            ) : null}

          <Grid item xs={12} sm={6}>
            <TextField
              label="Reason of Requirement"
              name="reasonOfRequirement"
              value={formValue.reasonOfRequirement}
              onChange={handleInputChange}
              fullWidth
              required
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <Autocomplete
              disablePortal
              options={managers}
              getOptionLabel={(manager) => manager.name}
              getOptionKey={(manager) => manager.id}
              onChange={(event, value) => setFormValue((prevValues) => ({
                ...prevValues,
                approvalManager: value?.id || ''
              }))}
              value={managers.find(manager => manager.id === formValue.approvalManager) || null}
              sx={{ width: '100%' }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Approval Manager"
                  required
                />
              )}
            />
          </Grid>
        </Grid>

        <Button type="submit" variant="contained" color="primary" fullWidth sx={{ marginTop: 4 }}>
          Submit
        </Button>
      </form>
    </Paper>
  );
}